import {colors} from 'js-libs/sweetcommons/styles';
import styled, {StyledComponent} from 'styled-components';

import {browserIs} from 'app/utils/browser';

// table styles taken from bootstrap

export const StyledUserContentDiv = styled.div.attrs<{className?: string}>(
  () => ({
    // https://github.com/SweetProcess/sweetprocess.com/pull/6632
    className: browserIs(['ie', 'edge']) ? 'clearfix' : '',
  })
)`
  display: flow-root;
  overflow-wrap: break-word;

  .fr-view {
    h4 {
      font-size: 1.3rem;
    }
    h5 {
      font-size: 1.1rem;
    }
  }

  table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    /* react-slick https://github.com/SweetProcess/sweetprocess.com/pull/11329: fixes carousel width calculation inside table cells */
    table-layout: fixed;

    th,
    td {
      padding: 0.75rem;
      vertical-align: top;
      border: 1px solid ${colors.borderGray};
    }

    th {
      background-color: #fafafa;
      border-bottom-color: ${colors.darkGray};
    }

    thead th {
      vertical-align: bottom;
    }

    tbody + tbody {
      border-top: 2px solid ${colors.darkGray};
    }
  }

  pre {
    background-color: ${colors.lightBg};
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    padding: 9.5px;
    white-space: pre-wrap;
  }

  blockquote {
    padding: 0 0 0 15px;
    margin: 0 0 20px;
    border-left: 5px solid ${colors.lightBg};
  }
`;

export const StyledUserContentWithEditGuidesDiv = styled<
  StyledComponent<'div', any>
>(StyledUserContentDiv).attrs<{className: string}>({
  className: 'notranslate',
})`
  &.fr-box.fr-basic {
    border-radius: 0.25rem;

    > .fr-toolbar.fr-top:not(.fr-sticky-on) {
      border-radius: 0.25rem 0.25rem 0 0;
    }
  }
  .fr-view {
    h4 {
      font-size: 1.3rem;
    }
    h5 {
      font-size: 1.1rem;
    }
  }

  // temporary workaround for https://github.com/SweetProcess/sweetprocess.com/pull/5007#issuecomment-519664231
  .fr-toolbar .fr-btn-grp .fr-command.fr-btn.fr-active:not(.fr-dropdown) i,
  .fr-toolbar .fr-more-toolbar .fr-command.fr-btn.fr-active:not(.fr-dropdown) i,
  .fr-toolbar
    .fr-buttons:not(.fr-tabs)
    .fr-command.fr-btn.fr-active:not(.fr-dropdown)
    i,
  .fr-popup .fr-btn-grp .fr-command.fr-btn.fr-active:not(.fr-dropdown) i,
  .fr-popup .fr-more-toolbar .fr-command.fr-btn.fr-active:not(.fr-dropdown) i,
  .fr-popup
    .fr-buttons:not(.fr-tabs)
    .fr-command.fr-btn.fr-active:not(.fr-dropdown)
    i,
  .fr-modal .fr-btn-grp .fr-command.fr-btn.fr-active:not(.fr-dropdown) i,
  .fr-modal .fr-more-toolbar .fr-command.fr-btn.fr-active:not(.fr-dropdown) i,
  .fr-modal
    .fr-buttons:not(.fr-tabs)
    .fr-command.fr-btn.fr-active:not(.fr-dropdown)
    i {
    color: #0098f7;
  }

  .fr-dropdown-list h5 {
    font-size: 0.9rem;
  }

  .fr-view table {
    border-top: 1px solid ${colors.lightBg};
    border-bottom: 1px solid ${colors.lightBg};

    th.fr-selected-cell,
    td.fr-selected-cell {
      border: 1px double #1e88e5;
    }

    td,
    th {
      border-left: 1px solid ${colors.borderGray};
      border-right: 1px solid ${colors.borderGray};
    }

    th {
      background-color: #fafafa;
    }
  }

  .fr-view a {
    outline: 1px solid rgba(0, 223, 252, 0.5);

    &:empty::after {
      content: 'empty link';
      font-size: 75%;
      opacity: 0.5;
      font-style: italic;
      padding: 0 2px;
    }
  }

  .fr-view a:hover {
    outline: 1px solid rgba(0, 223, 252, 0.75);
    background: rgba(0, 223, 252, 0.05);
  }
`;

export const StyledEditableStepFieldOrChoiceBoxDiv = styled.div`
  // https://stackoverflow.com/questions/39623405/vertically-stack-bootstrap-input-group-controls

  &.vertical-input-group {
    .input-group:first-of-type:not(:last-of-type) {
      * {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      & + .input-group *:not(.dropdown-menu) {
        border-top: none;
      }
    }

    .input-group:last-of-type:not(:first-of-type) *:not(.dropdown-menu) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    .input-group:not(:last-of-type):not(:first-of-type) *:not(.dropdown-menu) {
      border-radius: 0;
      border-bottom: none;
    }

    .input-group-sm > *:not(:focus) {
      box-shadow: none;
      border-top-color: #e9edf2;
    }

    // hide the dropdown caret which 'dropdown-toggle' class brings
    // we need the class to round corners
    .input-group .input-group-append .dropdown-toggle::after {
      display: none;
    }
  }
`;

export const StyledStepAttachedTitles = styled.h4`
  font-size: 90%;
  text-transform: uppercase;
  font-weight: bold;
`;

export const StyledStepAttachedLi = styled.li`
  cursor: pointer;
  &.active a {
    color: white !important;
  }
  &.ins {
    background-color: ${colors.insGreen};
  }
  &.del {
    background-color: ${colors.delRed};
  }
`;

export const ForegroundDiv = styled.div`
  button:disabled {
    pointer-events: none;
  }
`;

export const StyledDiffedImageContainerDiv = styled.div`
  &.ins {
    *:not(.embedded-obj) > img,
    *:not(.embedded-obj) > iframe,
    .embedded-obj {
      border: 5px solid ${colors.insGreen};
    }
  }

  &.del {
    *:not(.embedded-obj) > img,
    *:not(.embedded-obj) > iframe,
    .embedded-obj {
      border: 5px solid ${colors.delRed};
      > * {
        opacity: 0.5;
      }
    }
  }
`;

export const StyledStepNumberSpan = styled.span`
  display: block;
  height: 1.9em;
  width: 1.9em;
  font-size: 0.8em;
  font-weight: 700;
  color: ${colors.lightBg};
  background: ${colors.textDefault};
  border-radius: 50%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const StyledDocItem = styled.div`
  &:hover {
    color: inherit;
    background-color: ${colors.paleBlue};
  }
`;
